/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "Будда жылнаамасы",
          "chinese": "Кытай жылнаамасы",
          "coptic": "coptic",
          "dangi": "Данги жылнаамасы",
          "ethiopic": "Эфиоп жылнаамасы",
          "ethiopic-amete-alem": "ethiopic-amete-alem",
          "gregorian": "Григориан жылнаамасы",
          "hebrew": "Иврит жылнаамасы",
          "indian": "indian",
          "islamic": "Ислам жылнаамасы",
          "islamic-civil": "islamic-civil",
          "islamic-rgsa": "islamic-rgsa",
          "islamic-tbla": "islamic-tbla",
          "islamic-umalqura": "islamic-umalqura",
          "iso8601": "ИСО-8601 жылнаамасы",
          "japanese": "Жапон жылнаамасы",
          "persian": "Перс жылнаамасы",
          "roc": "Мингуо жылнаамасы"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "ADP",
          "AED": "Бириккен Араб Эмираттарынын дирхамы",
          "AFA": "AFA",
          "AFN": "Афганстан афганиси",
          "ALK": "ALK",
          "ALL": "албан леги",
          "AMD": "Армения драмы",
          "ANG": "нидерланд-антил гулдени",
          "AOA": "Ангола кванзасы",
          "AOK": "AOK",
          "AON": "AON",
          "AOR": "AOR",
          "ARA": "ARA",
          "ARL": "ARL",
          "ARM": "ARM",
          "ARP": "ARP",
          "ARS": "аргентина песосу",
          "ATS": "ATS",
          "AUD": "Австралия доллары",
          "AWG": "аруба флорини",
          "AZM": "AZM",
          "AZN": "Азербайжан манаты",
          "BAD": "BAD",
          "BAM": "босния-герцоговина конвертациялануучу маркасы",
          "BAN": "BAN",
          "BBD": "барбадос доллары",
          "BDT": "Бангладеш такасы",
          "BEC": "BEC",
          "BEF": "BEF",
          "BEL": "BEL",
          "BGL": "BGL",
          "BGM": "BGM",
          "BGN": "болгар левиси",
          "BGO": "BGO",
          "BHD": "Бахрейн динары",
          "BIF": "Бурунди франкы",
          "BMD": "бермуд доллары",
          "BND": "Бруней доллары",
          "BOB": "боливия боливианосу",
          "BOL": "BOL",
          "BOP": "BOP",
          "BOV": "BOV",
          "BRB": "BRB",
          "BRC": "BRC",
          "BRE": "BRE",
          "BRL": "бразилия реалы",
          "BRN": "BRN",
          "BRR": "BRR",
          "BRZ": "BRZ",
          "BSD": "багама доллары",
          "BTN": "Бутан нгултруму",
          "BUK": "BUK",
          "BWP": "Ботсвана пуласы",
          "BYB": "BYB",
          "BYN": "беларусь рублу",
          "BYR": "беларусь рублу (2000–2016)",
          "BZD": "белиз доллары",
          "CAD": "канада доллары",
          "CDF": "Конго франкы",
          "CHE": "CHE",
          "CHF": "швейцария франкы",
          "CHW": "CHW",
          "CLE": "CLE",
          "CLF": "CLF",
          "CLP": "чили песосу",
          "CNH": "Кытай юаны (оффшор)",
          "CNX": "CNX",
          "CNY": "Кытай юаны",
          "COP": "колумбия песосу",
          "COU": "COU",
          "CRC": "коста-рика колону",
          "CSD": "CSD",
          "CSK": "CSK",
          "CUC": "кубанын конвертациялануучу песосу",
          "CUP": "куба песосу",
          "CVE": "Кабо-Верде эскудосу",
          "CYP": "CYP",
          "CZK": "чех кронасы",
          "DDM": "DDM",
          "DEM": "DEM",
          "DJF": "Жибути франкы",
          "DKK": "дания крону",
          "DOP": "доминикан песосу",
          "DZD": "алжир динары",
          "ECS": "ECS",
          "ECV": "ECV",
          "EEK": "EEK",
          "EGP": "египет фунту",
          "ERN": "Эритреа накфасы",
          "ESA": "ESA",
          "ESB": "ESB",
          "ESP": "ESP",
          "ETB": "Эфиопия бирри",
          "EUR": "Евро",
          "FIM": "FIM",
          "FJD": "Фижи доллары",
          "FKP": "фолкленд аралдарынын фунту",
          "FRF": "FRF",
          "GBP": "британия фунт стерлинги",
          "GEK": "GEK",
          "GEL": "Грузия лариси",
          "GHC": "GHC",
          "GHS": "Гана седиси",
          "GIP": "гибралтар фунту",
          "GMD": "Гамбия даласиси",
          "GNF": "Гине франкы",
          "GNS": "GNS",
          "GQE": "GQE",
          "GRD": "GRD",
          "GTQ": "гватемала кетсалы",
          "GWE": "GWE",
          "GWP": "GWP",
          "GYD": "гуйана доллары",
          "HKD": "Гонконг доллары",
          "HNL": "гондурас лемпирасы",
          "HRD": "HRD",
          "HRK": "хорват кунасы",
          "HTG": "гаити гурдусу",
          "HUF": "венгр форинти",
          "IDR": "Индонезия рупийасы",
          "IEP": "IEP",
          "ILP": "ILP",
          "ILR": "ILR",
          "ILS": "Израилдин жаңы шекели",
          "INR": "Индия руписи",
          "IQD": "Ирак динары",
          "IRR": "Иран риалы",
          "ISJ": "ISJ",
          "ISK": "исландия крону",
          "ITL": "ITL",
          "JMD": "ямайка доллары",
          "JOD": "Йордания динары",
          "JPY": "Жапан йени",
          "KES": "Кения шиллинги",
          "KGS": "Кыргызстан сому",
          "KHR": "Камбожа риели",
          "KMF": "Коморос франкы",
          "KPW": "Түндүк Корея вону",
          "KRH": "KRH",
          "KRO": "KRO",
          "KRW": "Түштүк Корея вону",
          "KWD": "Кувейт динары",
          "KYD": "кайман доллары",
          "KZT": "Казакстан теңгеси",
          "LAK": "Лаос киби",
          "LBP": "Ливан фунту",
          "LKR": "Шри Ланка руписи",
          "LRD": "Либерия доллары",
          "LSL": "Лесото лотиси",
          "LTL": "литва литасы",
          "LTT": "LTT",
          "LUC": "LUC",
          "LUF": "LUF",
          "LUL": "LUL",
          "LVL": "латвия латы",
          "LVR": "LVR",
          "LYD": "ливия динары",
          "MAD": "марокко дирхамы",
          "MAF": "MAF",
          "MCF": "MCF",
          "MDC": "MDC",
          "MDL": "молдован лейи",
          "MGA": "Мадагаскар ариариси",
          "MGF": "MGF",
          "MKD": "македон денары",
          "MKN": "MKN",
          "MLF": "MLF",
          "MMK": "Мйанмар кйаты",
          "MNT": "Монгол тугриги",
          "MOP": "Макау патакасы",
          "MRO": "Мавритания угиясы (1973–2017)",
          "MRU": "Мавритания угиясы",
          "MTL": "MTL",
          "MTP": "MTP",
          "MUR": "Мавританий руписи",
          "MVP": "MVP",
          "MVR": "Малдив руфийасы",
          "MWK": "Малави квачасы",
          "MXN": "мексика песосу",
          "MXP": "MXP",
          "MXV": "MXV",
          "MYR": "Малайзия ринггити",
          "MZE": "MZE",
          "MZM": "MZM",
          "MZN": "Мозамбик метикалы",
          "NAD": "Намибия доллары",
          "NGN": "Нигерия найрасы",
          "NIC": "NIC",
          "NIO": "никарагуа кордобасы",
          "NLG": "NLG",
          "NOK": "норвегия крону",
          "NPR": "Непал руписи",
          "NZD": "Жаңы Зеландия доллары",
          "OMR": "Оман риалы",
          "PAB": "панама балбоасы",
          "PEI": "PEI",
          "PEN": "перу солу",
          "PES": "PES",
          "PGK": "Папуа Жаңы Гвинея кинасы",
          "PHP": "Филиппин песосу",
          "PKR": "Пакистан руписи",
          "PLN": "польша злотыйы",
          "PLZ": "PLZ",
          "PTE": "PTE",
          "PYG": "парагвай гуараниси",
          "QAR": "Катар риалы",
          "RHD": "RHD",
          "ROL": "ROL",
          "RON": "румын лейи",
          "RSD": "серб динары",
          "RUB": "орус рублу",
          "RUR": "RUR",
          "RWF": "Руанда франкы",
          "SAR": "Сауд риалы",
          "SBD": "Соломон аралдарынын доллары",
          "SCR": "Сейшел руписи",
          "SDD": "SDD",
          "SDG": "судан фунту",
          "SDP": "SDP",
          "SEK": "швеция крону",
          "SGD": "Сингапур доллары",
          "SHP": "Ыйык Елена аралынын фунту",
          "SIT": "SIT",
          "SKK": "SKK",
          "SLL": "Сиерра-Леоне леонеси",
          "SOS": "Сомали шиллинги",
          "SRD": "суринам доллары",
          "SRG": "SRG",
          "SSP": "Түштүк Судан фунту",
          "STD": "Сао Томе жана Принсипе добрасы (1977–2017)",
          "STN": "Сао Томе жана Принсипе добрасы",
          "SUR": "SUR",
          "SVC": "SVC",
          "SYP": "Сирия фунту",
          "SZL": "Свази лилангени",
          "THB": "Тай баты",
          "TJR": "TJR",
          "TJS": "Тажикстан сомониси",
          "TMM": "TMM",
          "TMT": "Түркмөнстан манаты",
          "TND": "тунис динары",
          "TOP": "Тонга паангасы",
          "TPE": "TPE",
          "TRL": "TRL",
          "TRY": "Түркия лирасы",
          "TTD": "тринидад жана тобаго доллары",
          "TWD": "Тайвань жаңы доллары",
          "TZS": "Танзания шиллинги",
          "UAH": "украин гривени",
          "UAK": "UAK",
          "UGS": "UGS",
          "UGX": "Уганда шиллинги",
          "USD": "АКШ доллары",
          "USN": "USN",
          "USS": "USS",
          "UYI": "UYI",
          "UYP": "UYP",
          "UYU": "уругвай песосу",
          "UYW": "UYW",
          "UZS": "Өзбекстан суму",
          "VEB": "VEB",
          "VEF": "венесуэла боливары (2008–2018)",
          "VES": "Венесуэла боливары",
          "VND": "Вьетнам доңу",
          "VNN": "VNN",
          "VUV": "Вануату ватусу",
          "WST": "Самоа таласы",
          "XAF": "Борбордук Африка КФА франкы",
          "XAG": "XAG",
          "XAU": "XAU",
          "XBA": "XBA",
          "XBB": "XBB",
          "XBC": "XBC",
          "XBD": "XBD",
          "XCD": "чыгыш кариб доллары",
          "XDR": "XDR",
          "XEU": "XEU",
          "XFO": "XFO",
          "XFU": "XFU",
          "XOF": "КФА франкы",
          "XPD": "XPD",
          "XPF": "КФП франкы",
          "XPT": "XPT",
          "XRE": "XRE",
          "XSU": "XSU",
          "XTS": "XTS",
          "XUA": "XUA",
          "XXX": "Белгисиз акча",
          "YDD": "YDD",
          "YER": "Йемен риалы",
          "YUD": "YUD",
          "YUM": "YUM",
          "YUN": "YUN",
          "YUR": "YUR",
          "ZAL": "ZAL",
          "ZAR": "Түштүк Африка ранды",
          "ZMK": "ZMK",
          "ZMW": "Замбия квачасы",
          "ZRN": "ZRN",
          "ZRZ": "ZRZ",
          "ZWD": "ZWD",
          "ZWL": "ZWL",
          "ZWR": "ZWR"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "күн",
          "dayOfYear": "жылдын күнү",
          "dayperiod": "ТЧ/ТК",
          "era": "заман",
          "hour": "саат",
          "minute": "мүнөт",
          "month": "ай",
          "quarter": "чейрек",
          "second": "секунд",
          "timeZoneName": "убакыт алкагы",
          "weekOfMonth": "айдын жумасы",
          "weekOfYear": "апта",
          "weekday": "аптанын күнү",
          "weekdayOfMonth": "айдын жумуш күнү",
          "year": "жыл"
        },
        "narrow": {
          "day": "күн",
          "dayOfYear": "жылдын күнү",
          "dayperiod": "тң/тк",
          "era": "заман",
          "hour": "ст",
          "minute": "м.",
          "month": "ай",
          "quarter": "чейр.",
          "second": "сек.",
          "timeZoneName": "убакыт алкагы",
          "weekOfMonth": "айдын жумасы",
          "weekOfYear": "апт",
          "weekday": "аптанын күнү",
          "weekdayOfMonth": "айдын жумуш күнү",
          "year": "ж."
        },
        "short": {
          "day": "күн",
          "dayOfYear": "жылдын күнү",
          "dayperiod": "тң/тк",
          "era": "заман",
          "hour": "ст",
          "minute": "мүн.",
          "month": "ай",
          "quarter": "чейр.",
          "second": "сек.",
          "timeZoneName": "убакыт алкагы",
          "weekOfMonth": "айдын жумасы",
          "weekOfYear": "апт",
          "weekday": "аптанын күнү",
          "weekdayOfMonth": "айдын жумуш күнү",
          "year": "ж."
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "афарча",
            "ab": "абхазча",
            "ace": "ачехче",
            "ada": "адаңмече",
            "ady": "адыгейче",
            "af": "африкаанча",
            "agq": "агемче",
            "ain": "айнуча",
            "ak": "аканча",
            "ale": "алеутча",
            "alt": "түштүк алтайча",
            "am": "амхарча",
            "an": "арагончо",
            "anp": "ангикача",
            "ar": "арабча",
            "ar-001": "азыркы адабий араб тилинде",
            "arn": "мапучече",
            "arp": "арапахочо",
            "as": "ассамча",
            "asa": "асуча",
            "ast": "астурийче",
            "av": "аварикче",
            "awa": "авадхиче",
            "ay": "аймарача",
            "az": "азербайжанча",
            "ba": "башкырча",
            "ban": "баличе",
            "bas": "басаача",
            "be": "беларусча",
            "bem": "бембача",
            "bez": "бенача",
            "bg": "болгарча",
            "bgn": "чыгыш балучиче",
            "bho": "бхожпуриче",
            "bi": "бисламача",
            "bin": "биниче",
            "bla": "сиксикача",
            "bm": "бамбарача",
            "bn": "бангладешче",
            "bo": "тибетче",
            "br": "бретончо",
            "brx": "бодочо",
            "bs": "боснийче",
            "bug": "бугийче",
            "byn": "блинче",
            "ca": "каталончо",
            "ccp": "чакма",
            "ce": "чеченче",
            "ceb": "себуанча",
            "cgg": "чигача",
            "ch": "чаморрочо",
            "chk": "чуукиче",
            "chm": "мариче",
            "cho": "чокточо",
            "chr": "черокиче",
            "chy": "шайеннче",
            "ckb": "борбордук курдча",
            "co": "корсиканча",
            "crs": "сеселва креол французча",
            "cs": "чехче",
            "cu": "чиркөө славянча",
            "cv": "чувашча",
            "cy": "уелшче",
            "da": "датча",
            "dak": "дакотача",
            "dar": "даргинче",
            "dav": "таитача",
            "de": "немисче",
            "de-AT": "немисче (Австрия)",
            "de-CH": "адабий немисче (Швейцария)",
            "dgr": "догрибче",
            "dje": "зармача",
            "doi": "догриче",
            "dsb": "төмөнкү сорбианча",
            "dua": "дуалача",
            "dv": "дивехиче",
            "dyo": "жола-фониче",
            "dz": "жонгуча",
            "dzg": "дазагача",
            "ebu": "эмбуча",
            "ee": "эбече",
            "efi": "эфикче",
            "eka": "экажукча",
            "el": "грекче",
            "en": "англисче",
            "en-AU": "англисче (Австралия)",
            "en-CA": "англисче (Канада)",
            "en-GB": "англисче (Улуу Британия)",
            "en-US": "англисче (Америка Кошмо Штаттары)",
            "eo": "эсперанто",
            "es": "испанча",
            "es-419": "испанча (Латын Америкасы)",
            "es-ES": "испанча (Европа)",
            "es-MX": "испанча (Мексика)",
            "et": "эстончо",
            "eu": "баскча",
            "ewo": "эвондочо",
            "fa": "фарсча",
            "fa-AF": "дари",
            "ff": "фулача",
            "fi": "финче",
            "fil": "филипинче",
            "fj": "фижиче",
            "fo": "фарерче",
            "fon": "фончо",
            "fr": "французча",
            "fr-CA": "французча (Канада)",
            "fr-CH": "французча (Швейцария)",
            "frc": "frc",
            "fur": "фриулча",
            "fy": "батыш фризче",
            "ga": "ирландча",
            "gaa": "гача",
            "gag": "гагаузча",
            "gan": "Гань Кытайча",
            "gd": "шотладиялык гелча",
            "gez": "гиизче",
            "gil": "гилбертче",
            "gl": "галисияча",
            "gn": "гуараниче",
            "gor": "горонталочо",
            "gsw": "немисче (Швейцария)",
            "gu": "гужаратча",
            "guz": "гусиче",
            "gv": "мэнксыча",
            "gwi": "гвичинче",
            "ha": "хаусача",
            "hak": "Хакка кытайча",
            "haw": "гавайча",
            "he": "ивритче",
            "hi": "хиндиче",
            "hil": "хилигайнончо",
            "hmn": "хмонгчо",
            "hr": "хорватча",
            "hsb": "жогорку сорбианча",
            "hsn": "Сянь Кытайча",
            "ht": "гаитиче",
            "hu": "венгерче",
            "hup": "хупача",
            "hy": "армянча",
            "hz": "герерочо",
            "ia": "интерлингва",
            "iba": "ибанча",
            "ibb": "ибибиочо",
            "id": "индонезияча",
            "ig": "игбочо",
            "ii": "сычуань йиче",
            "ilo": "илокочо",
            "inh": "ингушча",
            "io": "идочо",
            "is": "исландча",
            "it": "италиянча",
            "iu": "инуктитутча",
            "ja": "жапончо",
            "jbo": "ложбанча",
            "jgo": "нгомбача",
            "jmc": "мачамече",
            "jv": "жаванизче",
            "ka": "грузинче",
            "kab": "кабылча",
            "kac": "кахинче",
            "kaj": "джуча",
            "kam": "камбача",
            "kbd": "кабардинче",
            "kcg": "тяпча",
            "kde": "макондече",
            "kea": "кабувердиче",
            "kfo": "корочо",
            "kgp": "kgp",
            "kha": "хасиче",
            "khq": "койра чиниче",
            "ki": "кикуйиче",
            "kj": "куаньямача",
            "kk": "казакча",
            "kkj": "какочо",
            "kl": "калаалисутча",
            "kln": "каленжиче",
            "km": "кмерче",
            "kmb": "кимбундуча",
            "kn": "каннадача",
            "ko": "корейче",
            "koi": "коми-пермякча",
            "kok": "конканиче",
            "kpe": "кпеллече",
            "kr": "кануриче",
            "krc": "карачай-балкарча",
            "krl": "карелче",
            "kru": "курухча",
            "ks": "кашмирче",
            "ksb": "шамабалача",
            "ksf": "бафияча",
            "ksh": "колоньяча",
            "ku": "курдча",
            "kum": "кумыкча",
            "kv": "комиче",
            "kw": "корнишче",
            "ky": "кыргызча",
            "la": "латынча",
            "lad": "ладиночо",
            "lag": "лангиче",
            "lb": "люксембургча",
            "lez": "лезгинче",
            "lg": "гандача",
            "li": "лимбургиче",
            "lij": "lij",
            "lkt": "лакотача",
            "ln": "лингалача",
            "lo": "лаочо",
            "lou": "lou",
            "loz": "лозиче",
            "lrc": "түндүк луриче",
            "lt": "литовчо",
            "lu": "луба-катангача",
            "lua": "луба-лулуача",
            "lun": "лундача",
            "luo": "луочо",
            "lus": "мизочо",
            "luy": "лухияча",
            "lv": "латышча",
            "mad": "мадурисче",
            "mag": "магахиче",
            "mai": "маитиличе",
            "mak": "макасарча",
            "mas": "масайча",
            "mdf": "мокшача",
            "men": "мендече",
            "mer": "меруча",
            "mfe": "морисианча",
            "mg": "малагасча",
            "mgh": "макуача",
            "mgo": "метача",
            "mh": "маршаллча",
            "mi": "маориче",
            "mic": "микмакча",
            "min": "минанкабауча",
            "mk": "македончо",
            "ml": "малайаламча",
            "mn": "монголчо",
            "mni": "манипуриче",
            "moh": "мохаукча",
            "mos": "моссиче",
            "mr": "маратиче",
            "ms": "малайча",
            "mt": "малтизче",
            "mua": "мундангча",
            "mul": "бир нече тилде",
            "mus": "крикче",
            "mwl": "мирандизче",
            "my": "бурмача",
            "myv": "эрзянча",
            "mzn": "мазандераниче",
            "na": "науруча",
            "nap": "неополитанча",
            "naq": "намача",
            "nb": "норвежче (букмал)",
            "nd": "түндүк ндыбелче",
            "nds": "төмөнкү немисче",
            "nds-NL": "төмөнкү саксончо",
            "ne": "непалча",
            "new": "невариче",
            "ng": "ндонгача",
            "nia": "ниасча",
            "niu": "ньюанча",
            "nl": "голландча",
            "nl-BE": "фламандча",
            "nmg": "квасиочо",
            "nn": "норвежче (нинорск)",
            "nnh": "нгимбунча",
            "no": "норвежче",
            "nog": "ногайча",
            "nqo": "нкочо",
            "nr": "түштүк ндебелече",
            "nso": "түндүк соточо",
            "nus": "нуерче",
            "nv": "наваджочо",
            "ny": "ньянджача",
            "nyn": "ныйанколчо",
            "oc": "окситанча",
            "om": "оромочо",
            "or": "орияча",
            "os": "осетинче",
            "pa": "пунжабиче",
            "pag": "пангасиче",
            "pam": "пампангача",
            "pap": "папиаменточо",
            "pau": "палауанча",
            "pcm": "аргындашкан тил (Нигерия)",
            "pl": "полякча",
            "prg": "пруссча",
            "ps": "пуштуча",
            "pt": "португалча",
            "pt-BR": "португалча (Бразилия)",
            "pt-PT": "португалча (Европа)",
            "qu": "кечуача",
            "quc": "кичече",
            "rap": "рапаньюча",
            "rar": "раротонгача",
            "rhg": "рохинжача",
            "rm": "романшча",
            "rn": "рундиче",
            "ro": "румынча",
            "ro-MD": "молдованча",
            "rof": "ромбочо",
            "ru": "орусча",
            "rup": "аромунча",
            "rw": "руандача",
            "rwk": "руача",
            "sa": "санскритче",
            "sad": "сандавече",
            "sah": "сахача",
            "saq": "самбуруча",
            "sat": "санталиче",
            "sba": "нгамбайча",
            "sbp": "сангуча",
            "sc": "сардинче",
            "scn": "сицилийче",
            "sco": "шотландча",
            "sd": "синдхиче",
            "sdh": "түштүк курдча",
            "se": "түндүк саамиче",
            "seh": "сенача",
            "ses": "койраборо сенниче",
            "sg": "сангочо",
            "sh": "серб-хорват",
            "shi": "ташелитче",
            "shn": "шанча",
            "si": "сингалача",
            "sk": "словакча",
            "sl": "словенче",
            "sm": "самоанча",
            "sma": "түштүк саамиче",
            "smj": "луле саамиче",
            "smn": "инари саамиче",
            "sms": "сколт саамиче",
            "sn": "шонача",
            "snk": "сонинкече",
            "so": "сомаличе",
            "sq": "албанча",
            "sr": "сербче",
            "srn": "сранан тонгочо",
            "ss": "сватиче",
            "ssy": "сахочо",
            "st": "сесоточо",
            "su": "сунданча",
            "suk": "сукумача",
            "sv": "шведче",
            "sw": "суахиличе",
            "sw-CD": "конго суахаличе",
            "swb": "коморчо",
            "syr": "сирияча",
            "ta": "тамилче",
            "te": "телугуча",
            "tem": "тимнече",
            "teo": "тесочо",
            "tet": "тетумча",
            "tg": "тажикче",
            "th": "тайча",
            "ti": "тигриниача",
            "tig": "тигрече",
            "tk": "түркмөнчө",
            "tlh": "клингончо",
            "tn": "тсванача",
            "to": "тонгача",
            "tpi": "ток-писинче",
            "tr": "түркчө",
            "trv": "тарокочо",
            "ts": "тсонгача",
            "tt": "татарча",
            "tum": "тумбукача",
            "tvl": "тувалуча",
            "tw": "тви",
            "twq": "тасабакча",
            "ty": "таитиче",
            "tyv": "тувинче",
            "tzm": "борбордук Атлас тамазигтче",
            "udm": "удмуртча",
            "ug": "уйгурча",
            "uk": "украинче",
            "umb": "умбундуча",
            "und": "белгисиз тилде",
            "ur": "урдуча",
            "uz": "өзбекче",
            "vai": "вайиче",
            "ve": "вендача",
            "vi": "вьетнамча",
            "vo": "волапюкча",
            "vun": "вунжочо",
            "wa": "валлончо",
            "wae": "валцерче",
            "wal": "вольяттача",
            "war": "варайча",
            "wbp": "ворлпириче",
            "wo": "уолофчо",
            "xal": "калмыкча",
            "xh": "косача",
            "xog": "согача",
            "yav": "янгбенче",
            "ybb": "йембача",
            "yi": "идишче",
            "yo": "йорубача",
            "yrl": "yrl",
            "yue": "кантончо",
            "zgh": "марокко тамазигт адабий тилинде",
            "zh": "кытайча",
            "zh-Hans": "кытайча (жөнөкөйлөштүрүлгөн)",
            "zh-Hant": "кытайча (салттуу)",
            "zu": "зулуча",
            "zun": "зуниче",
            "zxx": "тилдик мазмун жок",
            "zza": "зазача"
          },
          "narrow": {
          },
          "short": {
            "az": "азерче",
            "en-GB": "англисче (УБ)",
            "en-US": "англисче (Америка Кошмо Штаттары)"
          }
        },
        "standard": {
          "long": {
            "aa": "афарча",
            "ab": "абхазча",
            "ace": "ачехче",
            "ada": "адаңмече",
            "ady": "адыгейче",
            "af": "африкаанча",
            "agq": "агемче",
            "ain": "айнуча",
            "ak": "аканча",
            "ale": "алеутча",
            "alt": "түштүк алтайча",
            "am": "амхарча",
            "an": "арагончо",
            "anp": "ангикача",
            "ar": "арабча",
            "ar-001": "арабча (Дүйнө)",
            "arn": "мапучече",
            "arp": "арапахочо",
            "as": "ассамча",
            "asa": "асуча",
            "ast": "астурийче",
            "av": "аварикче",
            "awa": "авадхиче",
            "ay": "аймарача",
            "az": "азербайжанча",
            "ba": "башкырча",
            "ban": "баличе",
            "bas": "басаача",
            "be": "беларусча",
            "bem": "бембача",
            "bez": "бенача",
            "bg": "болгарча",
            "bgn": "чыгыш балучиче",
            "bho": "бхожпуриче",
            "bi": "бисламача",
            "bin": "биниче",
            "bla": "сиксикача",
            "bm": "бамбарача",
            "bn": "бангладешче",
            "bo": "тибетче",
            "br": "бретончо",
            "brx": "бодочо",
            "bs": "боснийче",
            "bug": "бугийче",
            "byn": "блинче",
            "ca": "каталончо",
            "ccp": "чакма",
            "ce": "чеченче",
            "ceb": "себуанча",
            "cgg": "чигача",
            "ch": "чаморрочо",
            "chk": "чуукиче",
            "chm": "мариче",
            "cho": "чокточо",
            "chr": "черокиче",
            "chy": "шайеннче",
            "ckb": "борбордук курдча",
            "co": "корсиканча",
            "crs": "сеселва креол французча",
            "cs": "чехче",
            "cu": "чиркөө славянча",
            "cv": "чувашча",
            "cy": "уелшче",
            "da": "датча",
            "dak": "дакотача",
            "dar": "даргинче",
            "dav": "таитача",
            "de": "немисче",
            "de-AT": "немисче (Австрия)",
            "de-CH": "немисче (Швейцария)",
            "dgr": "догрибче",
            "dje": "зармача",
            "doi": "догриче",
            "dsb": "төмөнкү сорбианча",
            "dua": "дуалача",
            "dv": "дивехиче",
            "dyo": "жола-фониче",
            "dz": "жонгуча",
            "dzg": "дазагача",
            "ebu": "эмбуча",
            "ee": "эбече",
            "efi": "эфикче",
            "eka": "экажукча",
            "el": "грекче",
            "en": "англисче",
            "en-AU": "англисче (Австралия)",
            "en-CA": "англисче (Канада)",
            "en-GB": "англисче (Улуу Британия)",
            "en-US": "англисче (Кошмо Штаттар)",
            "eo": "эсперанто",
            "es": "испанча",
            "es-419": "испанча (Латын Америкасы)",
            "es-ES": "испанча (Испания)",
            "es-MX": "испанча (Мексика)",
            "et": "эстончо",
            "eu": "баскча",
            "ewo": "эвондочо",
            "fa": "фарсча",
            "fa-AF": "фарсча (Афганистан)",
            "ff": "фулача",
            "fi": "финче",
            "fil": "филипинче",
            "fj": "фижиче",
            "fo": "фарерче",
            "fon": "фончо",
            "fr": "французча",
            "fr-CA": "французча (Канада)",
            "fr-CH": "французча (Швейцария)",
            "frc": "frc",
            "fur": "фриулча",
            "fy": "батыш фризче",
            "ga": "ирландча",
            "gaa": "гача",
            "gag": "гагаузча",
            "gan": "Гань Кытайча",
            "gd": "шотладиялык гелча",
            "gez": "гиизче",
            "gil": "гилбертче",
            "gl": "галисияча",
            "gn": "гуараниче",
            "gor": "горонталочо",
            "gsw": "немисче (Швейцария)",
            "gu": "гужаратча",
            "guz": "гусиче",
            "gv": "мэнксыча",
            "gwi": "гвичинче",
            "ha": "хаусача",
            "hak": "Хакка кытайча",
            "haw": "гавайча",
            "he": "ивритче",
            "hi": "хиндиче",
            "hil": "хилигайнончо",
            "hmn": "хмонгчо",
            "hr": "хорватча",
            "hsb": "жогорку сорбианча",
            "hsn": "Сянь Кытайча",
            "ht": "гаитиче",
            "hu": "венгерче",
            "hup": "хупача",
            "hy": "армянча",
            "hz": "герерочо",
            "ia": "интерлингва",
            "iba": "ибанча",
            "ibb": "ибибиочо",
            "id": "индонезияча",
            "ig": "игбочо",
            "ii": "сычуань йиче",
            "ilo": "илокочо",
            "inh": "ингушча",
            "io": "идочо",
            "is": "исландча",
            "it": "италиянча",
            "iu": "инуктитутча",
            "ja": "жапончо",
            "jbo": "ложбанча",
            "jgo": "нгомбача",
            "jmc": "мачамече",
            "jv": "жаванизче",
            "ka": "грузинче",
            "kab": "кабылча",
            "kac": "кахинче",
            "kaj": "джуча",
            "kam": "камбача",
            "kbd": "кабардинче",
            "kcg": "тяпча",
            "kde": "макондече",
            "kea": "кабувердиче",
            "kfo": "корочо",
            "kgp": "kgp",
            "kha": "хасиче",
            "khq": "койра чиниче",
            "ki": "кикуйиче",
            "kj": "куаньямача",
            "kk": "казакча",
            "kkj": "какочо",
            "kl": "калаалисутча",
            "kln": "каленжиче",
            "km": "кмерче",
            "kmb": "кимбундуча",
            "kn": "каннадача",
            "ko": "корейче",
            "koi": "коми-пермякча",
            "kok": "конканиче",
            "kpe": "кпеллече",
            "kr": "кануриче",
            "krc": "карачай-балкарча",
            "krl": "карелче",
            "kru": "курухча",
            "ks": "кашмирче",
            "ksb": "шамабалача",
            "ksf": "бафияча",
            "ksh": "колоньяча",
            "ku": "курдча",
            "kum": "кумыкча",
            "kv": "комиче",
            "kw": "корнишче",
            "ky": "кыргызча",
            "la": "латынча",
            "lad": "ладиночо",
            "lag": "лангиче",
            "lb": "люксембургча",
            "lez": "лезгинче",
            "lg": "гандача",
            "li": "лимбургиче",
            "lij": "lij",
            "lkt": "лакотача",
            "ln": "лингалача",
            "lo": "лаочо",
            "lou": "lou",
            "loz": "лозиче",
            "lrc": "түндүк луриче",
            "lt": "литовчо",
            "lu": "луба-катангача",
            "lua": "луба-лулуача",
            "lun": "лундача",
            "luo": "луочо",
            "lus": "мизочо",
            "luy": "лухияча",
            "lv": "латышча",
            "mad": "мадурисче",
            "mag": "магахиче",
            "mai": "маитиличе",
            "mak": "макасарча",
            "mas": "масайча",
            "mdf": "мокшача",
            "men": "мендече",
            "mer": "меруча",
            "mfe": "морисианча",
            "mg": "малагасча",
            "mgh": "макуача",
            "mgo": "метача",
            "mh": "маршаллча",
            "mi": "маориче",
            "mic": "микмакча",
            "min": "минанкабауча",
            "mk": "македончо",
            "ml": "малайаламча",
            "mn": "монголчо",
            "mni": "манипуриче",
            "moh": "мохаукча",
            "mos": "моссиче",
            "mr": "маратиче",
            "ms": "малайча",
            "mt": "малтизче",
            "mua": "мундангча",
            "mul": "бир нече тилде",
            "mus": "крикче",
            "mwl": "мирандизче",
            "my": "бурмача",
            "myv": "эрзянча",
            "mzn": "мазандераниче",
            "na": "науруча",
            "nap": "неополитанча",
            "naq": "намача",
            "nb": "норвежче (букмал)",
            "nd": "түндүк ндыбелче",
            "nds": "төмөнкү немисче",
            "nds-NL": "төмөнкү немисче (Нидерланд)",
            "ne": "непалча",
            "new": "невариче",
            "ng": "ндонгача",
            "nia": "ниасча",
            "niu": "ньюанча",
            "nl": "голландча",
            "nl-BE": "голландча (Бельгия)",
            "nmg": "квасиочо",
            "nn": "норвежче (нинорск)",
            "nnh": "нгимбунча",
            "no": "норвежче",
            "nog": "ногайча",
            "nqo": "нкочо",
            "nr": "түштүк ндебелече",
            "nso": "түндүк соточо",
            "nus": "нуерче",
            "nv": "наваджочо",
            "ny": "ньянджача",
            "nyn": "ныйанколчо",
            "oc": "окситанча",
            "om": "оромочо",
            "or": "орияча",
            "os": "осетинче",
            "pa": "пунжабиче",
            "pag": "пангасиче",
            "pam": "пампангача",
            "pap": "папиаменточо",
            "pau": "палауанча",
            "pcm": "аргындашкан тил (Нигерия)",
            "pl": "полякча",
            "prg": "пруссча",
            "ps": "пуштуча",
            "pt": "португалча",
            "pt-BR": "португалча (Бразилия)",
            "pt-PT": "португалча (Португалия)",
            "qu": "кечуача",
            "quc": "кичече",
            "rap": "рапаньюча",
            "rar": "раротонгача",
            "rhg": "рохинжача",
            "rm": "романшча",
            "rn": "рундиче",
            "ro": "румынча",
            "ro-MD": "румынча (Молдова)",
            "rof": "ромбочо",
            "ru": "орусча",
            "rup": "аромунча",
            "rw": "руандача",
            "rwk": "руача",
            "sa": "санскритче",
            "sad": "сандавече",
            "sah": "сахача",
            "saq": "самбуруча",
            "sat": "санталиче",
            "sba": "нгамбайча",
            "sbp": "сангуча",
            "sc": "сардинче",
            "scn": "сицилийче",
            "sco": "шотландча",
            "sd": "синдхиче",
            "sdh": "түштүк курдча",
            "se": "түндүк саамиче",
            "seh": "сенача",
            "ses": "койраборо сенниче",
            "sg": "сангочо",
            "sh": "серб-хорват",
            "shi": "ташелитче",
            "shn": "шанча",
            "si": "сингалача",
            "sk": "словакча",
            "sl": "словенче",
            "sm": "самоанча",
            "sma": "түштүк саамиче",
            "smj": "луле саамиче",
            "smn": "инари саамиче",
            "sms": "сколт саамиче",
            "sn": "шонача",
            "snk": "сонинкече",
            "so": "сомаличе",
            "sq": "албанча",
            "sr": "сербче",
            "srn": "сранан тонгочо",
            "ss": "сватиче",
            "ssy": "сахочо",
            "st": "сесоточо",
            "su": "сунданча",
            "suk": "сукумача",
            "sv": "шведче",
            "sw": "суахиличе",
            "sw-CD": "суахиличе (Конго-Киншаса)",
            "swb": "коморчо",
            "syr": "сирияча",
            "ta": "тамилче",
            "te": "телугуча",
            "tem": "тимнече",
            "teo": "тесочо",
            "tet": "тетумча",
            "tg": "тажикче",
            "th": "тайча",
            "ti": "тигриниача",
            "tig": "тигрече",
            "tk": "түркмөнчө",
            "tlh": "клингончо",
            "tn": "тсванача",
            "to": "тонгача",
            "tpi": "ток-писинче",
            "tr": "түркчө",
            "trv": "тарокочо",
            "ts": "тсонгача",
            "tt": "татарча",
            "tum": "тумбукача",
            "tvl": "тувалуча",
            "tw": "тви",
            "twq": "тасабакча",
            "ty": "таитиче",
            "tyv": "тувинче",
            "tzm": "борбордук Атлас тамазигтче",
            "udm": "удмуртча",
            "ug": "уйгурча",
            "uk": "украинче",
            "umb": "умбундуча",
            "und": "белгисиз тилде",
            "ur": "урдуча",
            "uz": "өзбекче",
            "vai": "вайиче",
            "ve": "вендача",
            "vi": "вьетнамча",
            "vo": "волапюкча",
            "vun": "вунжочо",
            "wa": "валлончо",
            "wae": "валцерче",
            "wal": "вольяттача",
            "war": "варайча",
            "wbp": "ворлпириче",
            "wo": "уолофчо",
            "xal": "калмыкча",
            "xh": "косача",
            "xog": "согача",
            "yav": "янгбенче",
            "ybb": "йембача",
            "yi": "идишче",
            "yo": "йорубача",
            "yrl": "yrl",
            "yue": "кантончо",
            "zgh": "марокко тамазигт адабий тилинде",
            "zh": "кытайча",
            "zh-Hans": "кытайча (жөнөкөйлөштүрүлгөн)",
            "zh-Hant": "кытайча (салттуу)",
            "zu": "зулуча",
            "zun": "зуниче",
            "zxx": "тилдик мазмун жок",
            "zza": "зазача"
          },
          "narrow": {
          },
          "short": {
            "az": "азерче",
            "en-GB": "англисче (УБ)",
            "en-US": "англисче (АКШ)"
          }
        }
      },
      "region": {
        "long": {
          "001": "Дүйнө",
          "002": "Африка",
          "003": "Түндүк Америка",
          "005": "Түштүк Америка",
          "009": "Океания",
          "011": "Батыш Африка",
          "013": "Борбордук Америка",
          "014": "Чыгыш Африка",
          "015": "Түндүк Африка",
          "017": "Борбордук Африка",
          "018": "Түштүк Африка",
          "019": "Америка",
          "021": "Түндүк Америка (чөлкөм)",
          "029": "Кариб аралдары",
          "030": "Чыгыш Азия",
          "034": "Түштүк Азия",
          "035": "Түштүк-Чыгыш Азия",
          "039": "Түштүк Европа",
          "053": "Австралазия",
          "054": "Меланезия",
          "057": "Микронезия чөлкөмү",
          "061": "Полинезия",
          "142": "Азия",
          "143": "Борбор Азия",
          "145": "Батыш Азия",
          "150": "Европа",
          "151": "Чыгыш Европа",
          "154": "Түндүк Европа",
          "155": "Батыш Европа",
          "202": "Африка өлкөлөрү",
          "419": "Латын Америкасы",
          "AC": "Вознесение аралы",
          "AD": "Андорра",
          "AE": "Бириккен Араб Эмираттары",
          "AF": "Афганистан",
          "AG": "Антигуа жана Барбуда",
          "AI": "Ангилья",
          "AL": "Албания",
          "AM": "Армения",
          "AO": "Ангола",
          "AQ": "Антарктида",
          "AR": "Аргентина",
          "AS": "Америкалык Самоа",
          "AT": "Австрия",
          "AU": "Австралия",
          "AW": "Аруба",
          "AX": "Аланд аралдары",
          "AZ": "Азербайжан",
          "BA": "Босния жана Герцеговина",
          "BB": "Барбадос",
          "BD": "Бангладеш",
          "BE": "Бельгия",
          "BF": "Буркина-Фасо",
          "BG": "Болгария",
          "BH": "Бахрейн",
          "BI": "Бурунди",
          "BJ": "Бенин",
          "BL": "Сент Бартелеми",
          "BM": "Бермуд аралдары",
          "BN": "Бруней",
          "BO": "Боливия",
          "BQ": "Кариб Нидерланддары",
          "BR": "Бразилия",
          "BS": "Багама аралдары",
          "BT": "Бутан",
          "BV": "Буве аралы",
          "BW": "Ботсвана",
          "BY": "Беларусь",
          "BZ": "Белиз",
          "CA": "Канада",
          "CC": "Кокос (Килинг) аралдары",
          "CD": "Конго-Киншаса",
          "CF": "Борбордук Африка Республикасы",
          "CG": "Конго-Браззавил",
          "CH": "Швейцария",
          "CI": "Кот-д’Ивуар",
          "CK": "Кук аралдары",
          "CL": "Чили",
          "CM": "Камерун",
          "CN": "Кытай",
          "CO": "Колумбия",
          "CP": "Клиппертон аралы",
          "CR": "Коста-Рика",
          "CU": "Куба",
          "CV": "Кабо-Верде",
          "CW": "Кюрасао",
          "CX": "Рождество аралы",
          "CY": "Кипр",
          "CZ": "Чехия",
          "DE": "Германия",
          "DG": "Диего Гарсия",
          "DJ": "Джибути",
          "DK": "Дания",
          "DM": "Доминика",
          "DO": "Доминика Республикасы",
          "DZ": "Алжир",
          "EA": "Сеута жана Мелилла",
          "EC": "Эквадор",
          "EE": "Эстония",
          "EG": "Египет",
          "EH": "Батыш Сахара",
          "ER": "Эритрея",
          "ES": "Испания",
          "ET": "Эфиопия",
          "EU": "Европа Биримдиги",
          "EZ": "Еврозона",
          "FI": "Финляндия",
          "FJ": "Фиджи",
          "FK": "Фолкленд аралдары",
          "FM": "Микронезия",
          "FO": "Фарер аралдары",
          "FR": "Франция",
          "GA": "Габон",
          "GB": "Улуу Британия",
          "GD": "Гренада",
          "GE": "Грузия",
          "GF": "Француздук Гвиана",
          "GG": "Гернси",
          "GH": "Гана",
          "GI": "Гибралтар",
          "GL": "Гренландия",
          "GM": "Гамбия",
          "GN": "Гвинея",
          "GP": "Гваделупа",
          "GQ": "Экватордук Гвинея",
          "GR": "Греция",
          "GS": "Түштүк Жоржия жана Түштүк Сэндвич аралдары",
          "GT": "Гватемала",
          "GU": "Гуам",
          "GW": "Гвинея-Бисау",
          "GY": "Гайана",
          "HK": "Гонконг Кытай ААА",
          "HM": "Херд жана Макдональд аралдары",
          "HN": "Гондурас",
          "HR": "Хорватия",
          "HT": "Гаити",
          "HU": "Венгрия",
          "IC": "Канар аралдары",
          "ID": "Индонезия",
          "IE": "Ирландия",
          "IL": "Израиль",
          "IM": "Мэн аралы",
          "IN": "Индия",
          "IO": "Инди океанындагы Британ территориясы",
          "IQ": "Ирак",
          "IR": "Иран",
          "IS": "Исландия",
          "IT": "Италия",
          "JE": "Жерси",
          "JM": "Ямайка",
          "JO": "Иордания",
          "JP": "Япония",
          "KE": "Кения",
          "KG": "Кыргызстан",
          "KH": "Камбоджа",
          "KI": "Кирибати",
          "KM": "Коморос",
          "KN": "Сент-Китс жана Невис",
          "KP": "Түндүк Корея",
          "KR": "Түштүк Корея",
          "KW": "Кувейт",
          "KY": "Кайман аралдары",
          "KZ": "Казакстан",
          "LA": "Лаос",
          "LB": "Ливан",
          "LC": "Сент-Люсия",
          "LI": "Лихтенштейн",
          "LK": "Шри-Ланка",
          "LR": "Либерия",
          "LS": "Лесото",
          "LT": "Литва",
          "LU": "Люксембург",
          "LV": "Латвия",
          "LY": "Ливия",
          "MA": "Марокко",
          "MC": "Монако",
          "MD": "Молдова",
          "ME": "Черногория",
          "MF": "Сент-Мартин",
          "MG": "Мадагаскар",
          "MH": "Маршалл аралдары",
          "MK": "Түндүк Македония",
          "ML": "Мали",
          "MM": "Мьянма (Бирма)",
          "MN": "Монголия",
          "MO": "Макао Кытай ААА",
          "MP": "Түндүк Мариана аралдары",
          "MQ": "Мартиника",
          "MR": "Мавритания",
          "MS": "Монтсеррат",
          "MT": "Мальта",
          "MU": "Маврикий",
          "MV": "Мальдив",
          "MW": "Малави",
          "MX": "Мексика",
          "MY": "Малайзия",
          "MZ": "Мозамбик",
          "NA": "Намибия",
          "NC": "Жаңы Каледония",
          "NE": "Нигер",
          "NF": "Норфолк аралы",
          "NG": "Нигерия",
          "NI": "Никарагуа",
          "NL": "Нидерланд",
          "NO": "Норвегия",
          "NP": "Непал",
          "NR": "Науру",
          "NU": "Ниуэ",
          "NZ": "Жаңы Зеландия",
          "OM": "Оман",
          "PA": "Панама",
          "PE": "Перу",
          "PF": "Полинезия (франциялык)",
          "PG": "Папуа-Жаңы Гвинея",
          "PH": "Филиппин",
          "PK": "Пакистан",
          "PL": "Польша",
          "PM": "Сен-Пьер жана Микелон",
          "PN": "Питкэрн аралдары",
          "PR": "Пуэрто-Рико",
          "PS": "Палестина аймактары",
          "PT": "Португалия",
          "PW": "Палау",
          "PY": "Парагвай",
          "QA": "Катар",
          "QO": "Алыскы Океания",
          "RE": "Реюньон",
          "RO": "Румыния",
          "RS": "Сербия",
          "RU": "Россия",
          "RW": "Руанда",
          "SA": "Сауд Арабиясы",
          "SB": "Соломон аралдары",
          "SC": "Сейшел аралдары",
          "SD": "Судан",
          "SE": "Швеция",
          "SG": "Сингапур",
          "SH": "Ыйык Елена",
          "SI": "Словения",
          "SJ": "Шпицберген жана Ян-Майен",
          "SK": "Словакия",
          "SL": "Сьерра-Леоне",
          "SM": "Сан Марино",
          "SN": "Сенегал",
          "SO": "Сомали",
          "SR": "Суринам",
          "SS": "Түштүк Судан",
          "ST": "Сан-Томе жана Принсипи",
          "SV": "Эль-Сальвадор",
          "SX": "Синт-Мартен",
          "SY": "Сирия",
          "SZ": "Свазиленд",
          "TA": "Тристан-да-Кунья",
          "TC": "Түркс жана Кайкос аралдары",
          "TD": "Чад",
          "TF": "Франциянын Түштүктөгү аймактары",
          "TG": "Того",
          "TH": "Тайланд",
          "TJ": "Тажикстан",
          "TK": "Токелау",
          "TL": "Тимор-Лесте",
          "TM": "Түркмөнстан",
          "TN": "Тунис",
          "TO": "Тонга",
          "TR": "Түркия",
          "TT": "Тринидад жана Тобаго",
          "TV": "Тувалу",
          "TW": "Тайвань",
          "TZ": "Танзания",
          "UA": "Украина",
          "UG": "Уганда",
          "UM": "АКШнын сырткы аралдары",
          "UN": "БУ",
          "US": "Кошмо Штаттар",
          "UY": "Уругвай",
          "UZ": "Өзбекстан",
          "VA": "Ватикан",
          "VC": "Сент-Винсент жана Гренадиндер",
          "VE": "Венесуэла",
          "VG": "Виргин аралдары (Британия)",
          "VI": "Виргин аралдары (АКШ)",
          "VN": "Вьетнам",
          "VU": "Вануату",
          "WF": "Уоллис жана Футуна",
          "WS": "Самоа",
          "XA": "Жасалма- Акцент",
          "XB": "Жасалма - эки тараптуу",
          "XK": "Косово",
          "YE": "Йемен",
          "YT": "Майотта",
          "ZA": "Түштүк-Африка Республикасы",
          "ZM": "Замбия",
          "ZW": "Зимбабве",
          "ZZ": "Белгисиз чөлкөм"
        },
        "narrow": {
        },
        "short": {
          "GB": "УБ",
          "HK": "Гонконг",
          "MO": "Макао",
          "PS": "Палестина",
          "US": "АКШ"
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "Араб",
          "Aran": "Aran",
          "Armi": "Armi",
          "Armn": "Армян",
          "Avst": "Avst",
          "Bali": "Bali",
          "Bamu": "Bamu",
          "Bass": "Bass",
          "Batk": "Batk",
          "Beng": "Бенгал",
          "Bhks": "Bhks",
          "Bopo": "Бопомофо",
          "Brah": "Brah",
          "Brai": "Брейл",
          "Bugi": "Bugi",
          "Buhd": "Buhd",
          "Cakm": "Cakm",
          "Cans": "Cans",
          "Cari": "Cari",
          "Cham": "Cham",
          "Cher": "Cher",
          "Chrs": "Chrs",
          "Copt": "Copt",
          "Cpmn": "Cpmn",
          "Cprt": "Cprt",
          "Cyrl": "Кирилл",
          "Deva": "Деванагари",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "Dsrt",
          "Dupl": "Dupl",
          "Egyp": "Egyp",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "Эфиоп",
          "Geor": "Грузин",
          "Glag": "Glag",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "Goth",
          "Gran": "Gran",
          "Grek": "Грек",
          "Gujr": "Гужарати",
          "Guru": "Гурмухи",
          "Hanb": "Ханб",
          "Hang": "Хангул",
          "Hani": "Хань",
          "Hano": "Hano",
          "Hans": "Жөнөкөйлөштүрүлгөн",
          "Hant": "Салттуу",
          "Hatr": "Hatr",
          "Hebr": "Иврит",
          "Hira": "Хирагана",
          "Hluw": "Hluw",
          "Hmng": "Hmng",
          "Hmnp": "Hmnp",
          "Hrkt": "Жапон силлабографиясы",
          "Hung": "Hung",
          "Ital": "Ital",
          "Jamo": "Джамо",
          "Java": "Java",
          "Jpan": "Жапан",
          "Kali": "Kali",
          "Kana": "Катакана",
          "Khar": "Khar",
          "Khmr": "Кмер",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "Каннада",
          "Kore": "Корей",
          "Kthi": "Kthi",
          "Lana": "Lana",
          "Laoo": "Лао",
          "Latn": "Латын",
          "Lepc": "Lepc",
          "Limb": "Limb",
          "Lina": "Lina",
          "Linb": "Linb",
          "Lisu": "Lisu",
          "Lyci": "Lyci",
          "Lydi": "Lydi",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "Mand",
          "Mani": "Mani",
          "Marc": "Marc",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "Merc",
          "Mero": "Mero",
          "Mlym": "Малайалам",
          "Modi": "Modi",
          "Mong": "Монгол",
          "Mroo": "Mroo",
          "Mtei": "Mtei",
          "Mult": "Mult",
          "Mymr": "Мйанмар",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "Nkoo",
          "Nshu": "Nshu",
          "Ogam": "Ogam",
          "Olck": "Olck",
          "Orkh": "Orkh",
          "Orya": "Орийа",
          "Osge": "Osge",
          "Osma": "Osma",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "Perm",
          "Phag": "Phag",
          "Phli": "Phli",
          "Phlp": "Phlp",
          "Phnx": "Phnx",
          "Plrd": "Plrd",
          "Prti": "Prti",
          "Qaag": "Qaag",
          "Rjng": "Rjng",
          "Rohg": "Rohg",
          "Runr": "Runr",
          "Samr": "Samr",
          "Sarb": "Sarb",
          "Saur": "Saur",
          "Sgnw": "Sgnw",
          "Shaw": "Shaw",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "Сингала",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "Sund",
          "Sylo": "Sylo",
          "Syrc": "Syrc",
          "Tagb": "Tagb",
          "Takr": "Takr",
          "Tale": "Tale",
          "Talu": "Talu",
          "Taml": "Тамил",
          "Tang": "Tang",
          "Tavt": "Tavt",
          "Telu": "Телу",
          "Tfng": "Tfng",
          "Tglg": "Tglg",
          "Thaa": "Таана",
          "Thai": "Тай",
          "Tibt": "Тибет",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "Ugar",
          "Vaii": "Vaii",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "Xpeo",
          "Xsux": "Xsux",
          "Yezi": "Yezi",
          "Yiii": "Yiii",
          "Zanb": "Zanb",
          "Zinh": "Zinh",
          "Zmth": "Математикалык маани",
          "Zsye": "Быйтыкча",
          "Zsym": "Белгилер",
          "Zxxx": "Жазылбаган",
          "Zyyy": "Жалпы",
          "Zzzz": "Белгисиз жазуу"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "ky"
})
}